import { render, staticRenderFns } from "./EncounterReader.vue?vue&type=template&id=5500e7f4"
import script from "./EncounterReader.vue?vue&type=script&lang=js"
export * from "./EncounterReader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5500e7f4')) {
      api.createRecord('5500e7f4', component.options)
    } else {
      api.reload('5500e7f4', component.options)
    }
    module.hot.accept("./EncounterReader.vue?vue&type=template&id=5500e7f4", function () {
      api.rerender('5500e7f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/encounter/EncounterReader.vue"
export default component.exports